const EventEmitter = {
  events: {},

  dispatch: function (event, data) {
    if (!this.events[event]) return;

    this.events[event].forEach((callback) => callback(data));
  },

  subscribe: function (event, callback, shouldFlush = false) {
    if (!this.events[event]) this.events[event] = [];

    if(shouldFlush){
      this.events[event] = []
    }

    this.events[event].push(callback);
  },

  unsubscribe(event, callback) {
    if (!this.events[event]) return;
    const filterListeners = (listener) => listener !== callback;
    this.events[event] = this.events[event].filter(filterListeners);
  }
};

module.exports = { EventEmitter };

/**
   * how to use
   * first Subscribe event
   * EventEmitter.subscribe("event_name", callbackfunction());
   *
   * then dispatch that event
   * EventEmitter.dispatch("event_name");
*/
